import { TypeEnum } from "@/api/hooks/useCustomers/useCustomers";
import FormInput from "@/components/Form/FormInput";
import SelectInput from "@/components/Form/SelectInput";
import { useTrans } from "@/translations";

import { FC } from "react";
import { UseFormReturn } from "react-hook-form";

import { MWMCustomerFormValues } from "../../types";

type CustomerDetailsFormProps = {
  formHandler: UseFormReturn<MWMCustomerFormValues>;
  isEdit?: boolean;
};

export const CustomerDetailsForm: FC<CustomerDetailsFormProps> = ({
  isEdit = false,
  formHandler,
}) => {
  const { t } = useTrans();

  const {
    register,
    control,
    formState: { errors },
  } = formHandler;

  const typeOptions = [
    {
      label: t("entities:customerTypeHOUSEHOLD"),
      value: TypeEnum.Household.toUpperCase(),
    },
    {
      label: t("entities:customerTypeBUSINESS"),
      value: TypeEnum.Business.toUpperCase(),
    },
  ];

  return (
    <div className="mr-3 flex-1 md:w-96">
      {!isEdit && (
        <h2 className="font-dm-sans mb-2 text-base font-medium">{`1. ${t(
          "formLabels:enterCustomerInformation",
        )}`}</h2>
      )}
      <div className="my-2">
        <FormInput
          name="name"
          label={t("formLabels:customerReference")}
          register={register}
          error={errors?.name}
          required
        />
      </div>
      <div className="my-2">
        <SelectInput
          name="type"
          label={t("formLabels:type")}
          control={control}
          options={typeOptions}
          required
          isDisabled={isEdit}
        />
      </div>
      <div className="my-2">
        <FormInput
          name="address"
          label={t("formLabels:address")}
          register={register}
          error={errors?.address}
        />
      </div>
      <div className="my-2">
        <FormInput
          name="postalCode"
          label={t("formLabels:postalCode")}
          register={register}
          error={errors?.postalCode}
        />
      </div>
      <div className="my-2">
        <FormInput
          name="postalRegion"
          label={t("formLabels:postalRegion")}
          register={register}
          error={errors?.postalRegion}
        />
      </div>
    </div>
  );
};
